import {
  Body,
  Cell,
  Header,
  HeaderCell,
  HeaderRow,
  Row,
  Table
} from '@table-library/react-table-library/table'

import { edit } from '@/router/utils'
import { EditButton } from '@/shared/components/action-buttons'
import { Pagination } from '@/shared/components/pagination'
import { HasAccess } from '@permify/react-role'
import { usePagination } from '@table-library/react-table-library/pagination'
import { useTheme } from '@table-library/react-table-library/theme'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Link, useSearchParams } from 'react-router-dom'

export const UserTable = (props) => {
  const { data } = props
  const { users, meta } = data
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const nodes = { nodes: users }

  const onPaginationChange = (_, state) => {
    const page = state.page + 1
    const perPage = searchParams.get('per_page')

    searchParams.set('page', page)
    searchParams.set('per_page', perPage)
    setSearchParams(searchParams)
  }

  const pagination = usePagination(
    nodes,
    {
      state: {
        page: searchParams.get('page') - 1 || 0,
        size: searchParams.get('per_page') || 10
      },
      onChange: onPaginationChange
    },
    {
      isServer: true
    }
  )

  const theme = useTheme({
    Table: `
      --data-table-library_grid-template-columns: 1fr 1fr 1fr 1fr 2fr 1fr 0.5fr;
    `,
    BaseCell: `
      &:nth-of-type(7) {
        right: 0px;
      }
    `
  })

  return (
    <>
      <Table
        data={nodes}
        pagination={pagination}
        className='h-max'
        layout={{ fixedHeader: true, custom: true }}
        theme={theme}
      >
        {(tableList) => (
          <>

            <Header>
              <HeaderRow>
                <HeaderCell>{t('common.firstName')}</HeaderCell>
                <HeaderCell>{t('email.one')}</HeaderCell>
                <HeaderCell>{t('userRole.one')}</HeaderCell>
                <HeaderCell>{t('status.one')}</HeaderCell>
                <HeaderCell>{t('company.one')}</HeaderCell>
                <HeaderCell>Último acceso</HeaderCell>
                <HeaderCell>{t('actions.other')}</HeaderCell>
              </HeaderRow>
            </Header>
            <Body>

              {tableList.map(
                (user) => (
                  <Row key={user.id} item={user.id}>
                    <Cell>{user.name}</Cell>
                    <Cell>{user.email}</Cell>
                    <Cell>{user.roles[0]?.nameText}</Cell>
                    <Cell>{user.active ? 'Activo' : 'Inactivo'} </Cell>
                    <Cell>{user.contractorCompanyName}</Cell>
                    <Cell>{user.relativeLastSignInAt}</Cell>
                    <Cell pinRight>
                      <HasAccess permissions='user#edit'>
                        <Link to={edit('users', user.id)}>
                          <EditButton />
                        </Link>
                      </HasAccess>
                    </Cell>
                  </Row>
                )
              )}
            </Body>
          </>
        )}
      </Table>

      <Pagination
        onPageChange={({ selected }) => pagination.fns.onSetPage(selected)}
        page={pagination.state.page}
        totalPage={meta?.pagination?.total_pages}
      />
    </>
  )
}

UserTable.propTypes = {
  data: PropTypes.shape({
    users: PropTypes.arrayOf(PropTypes.object),
    meta: PropTypes.object
  })
}
